import Autolinker from 'autolinker'

document.addEventListener("turbo:load", function() {
  document.querySelectorAll('div[data-autolink]').forEach(function (element) {
    element.innerHTML = Autolinker.link(element.innerHTML)
  })
})
